import { SxProps, Theme } from '@mui/material'

import { lineClamp } from '@utils/styles'

export const cardSx: SxProps<Theme> = {
  background: 'transparent',
  boxShadow: 'none',
  borderRadius: 0,
}

export const cardContentSx: SxProps<Theme> = {
  paddingX: 0,
  paddingY: '2.4rem',
}

export const cardActionsSx: SxProps<Theme> = {
  padding: 0,
}

export const titleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.main,
  textDecoration: 'none',
  overflowWrap: 'anywhere',
  ...lineClamp({ lines: 3 }),
}
